// extracted by mini-css-extract-plugin
export default {"errormodal":"ErrorPopup_errormodal__x+E9G","errormessage":"ErrorPopup_errormessage__B3sxd"};